import Service from './service.js';

export class BreakService extends Service {
    constructor() {
        super('#form-service-break', 'breakservice');

        this.epaper = false;
        this.refund = false;
        this.category = false;
        
        this.bonus = document.querySelector('#breakservice-bonus');
        this.deliverypicker = document.querySelector('#breakservice-deliveryrange');
        this.deliverystart = document.querySelector('[name="BreakService[deliverystart]"]');
        this.deliveryend = document.querySelector('[name="BreakService[deliveryend]"]');
        this.servicetype = document.querySelector('#breakservice-servicetype');
    };
    
    afterValidate(data) {
        if(data.status == 'ok') {
            this.validated = true;
            this.epaper = data.epaper;
            this.canbonus = data.bonus;
            this.refund = data.refund;
            this.category = data.category;
            this.deliverinfo = data.deliverinfo;
            
            this.servicetype.value = data.type;
            this.deliverystart.value = data.deliverystart;
            this.deliveryend.value = data.deliveryend;
            
            this.updateSummary();
            this.clearErrors();
            
            if(this.canbonus) {
                this.next();
            } else {
                this.next(true);
            }
            
            if (OVS.app.helper.isNoz) {
                (this.refund) ? OVS.app.helper.hide(this.buttons.submit) : OVS.app.helper.show(this.buttons.submit);
            }
        } else {
            this.error(data.error);
        }
    };
    
    updateBonusView(show) {
        if (show) {
            OVS.app.helper.hide('.bonus-wrapper');
            OVS.app.helper.show('.' + this.category);
        } else {
            OVS.app.helper.hide('.bonus-wrapper');
            OVS.app.helper.hide('.' + this.category);
        }
    };
    
    updateSummary() {
        (this.canbonus) ? this.updateBonusView(true) : this.updateBonusView(false);
        (this.epaper) ? OVS.app.helper.show('.canemail') : OVS.app.helper.hide('.canemail');
        (this.refund) ? OVS.app.helper.show('.refund') : OVS.app.helper.hide('.refund');
        super.updateSummary();
    };
};
